export enum WhiteSpace {
    normal,
    nowrap,
    pre,
    "pre-wrap",
    "pre-line",
    "break-spaces",

}